module.exports = __webpack_public_path__ + "img/icstable.925e40fe.svg";